import React from 'react';

function QuestionToAsk() {
    return (
        <div className="stack">
            <div className="row">
                <div className="col-md-12 text-align-center pad-1">
                    <h2 className="heading-1">Questions? Call 1-800-419-2122</h2>
                </div>
            </div>
        </div>
    );
}
export default QuestionToAsk;